// const casahertaAnonymousApiURL = 'http://localhost:3100/api/anonymous';
// const casahertaProtectedApiURL = 'http://localhost:3100/api/protected';

const casahertaAnonymousApiURL = 'https://smbookings-staging.herokuapp.com/api/anonymous';
const casahertaProtectedApiURL = 'https://smbookings-staging.herokuapp.com/api/protected';
export {
    casahertaAnonymousApiURL,
    casahertaProtectedApiURL,
};
